import script from "./BillInfoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BillInfoModal.vue?vue&type=script&setup=true&lang=ts"

import "./BillInfoModal.vue?vue&type=style&index=0&id=28a90c52&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28a90c52"]])

export default __exports__